import OfferteFormPro from "@/components/feature/OfferteFormPro";

export default function OfferteForm() {
  return (
    <OfferteFormPro
      formId="offerte-schuifpui-reparatie"
      formUrl="https://formspree.io/f/xgoqdank"
      defaultSubject="Schuifpui reparatie"
    />
  );
}